import { createContext, useMemo } from 'react';

import { useSelfConnections } from '@frontend/api/hooks/useSelfConnections';

import { BaseConnectionProvider } from './BaseConnectionProvider';
import { ConnectionContextType } from './connectionUtils';

const ChatConnectionContext = createContext<ConnectionContextType>({
  products: {},
});

const ChatConnectionProvider = ({ children }: { children: React.ReactNode }) => {
  const { selfConnectionsQuery } = useSelfConnections();

  const connectionGetter = useMemo(
    () => ({
      connections: selfConnectionsQuery.data || [],
      isPending: selfConnectionsQuery.isPending,
      error: selfConnectionsQuery.error,
    }),
    [selfConnectionsQuery.data, selfConnectionsQuery.isPending, selfConnectionsQuery.error]
  );

  return (
    <BaseConnectionProvider connectionGetter={connectionGetter} context={ChatConnectionContext}>
      {children}
    </BaseConnectionProvider>
  );
};

export { ChatConnectionContext, ChatConnectionProvider };
